import FormattedMessage from 'I18n/components/FormattedMessage';
import { addSuccess, addDanger, addWarning
// @ts-expect-error untyped customer-data-ui-utilities
} from 'customer-data-ui-utilities/alerts/Alerts';
import { jsx as _jsx } from "react/jsx-runtime";
export const handleEmailReminderOnSuccess = () => addSuccess('invoices.alerts.emailReminders.success');
export const handleEmailReminderOnError = () => addDanger('invoices.alerts.emailReminders.danger');
export const handleOnGenericError = () => addDanger('invoices.alerts.generic.danger');
export const handleVoidOnSuccess = () => addSuccess('invoices.alerts.void.success', {}, {
  'data-test-id': 'void-invoice-success'
});
export const handleVoidOnError = () => addDanger('invoices.alerts.void.danger');
export const handleDeleteOnSuccess = () => addSuccess('invoices.alerts.delete.success', {}, {
  'data-test-id': 'delete-invoice-success'
});
export const handleDeleteOnError = () => addDanger('invoices.alerts.delete.danger');
export const handleSendOnSuccess = source => {
  return () => addSuccess('invoices.alerts.sendEmail.success.message', {}, {
    'data-test-id': `${source}-send-invoice-success`,
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "invoices.alerts.sendEmail.success.titleText"
    })
  });
};
export const handleSendOnError = () => addDanger('invoices.alerts.sendEmail.error.message', {}, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.alerts.sendEmail.error.titleText"
  })
});
export const handleSendOnRateLimitExceededError = () => addDanger('invoices.alerts.sendEmail.rateLimitExceededError.message', {}, {
  titleText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoices.alerts.sendEmail.rateLimitExceededError.titleText"
  })
});
export const handleRecordPaymentOnError = () => addDanger('invoices.alerts.recordPayment.danger');
export const handleRecordPaymentOnErrorOutdated = () => addDanger('invoices.alerts.recordPayment.dangerOutdatedInvoice');
export const handleDownloadOnFailure = () => addWarning('invoices.alerts.download.warning');